import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'Avatars';

const AvatarsApi: any = baseApi(endpoint);

export default AvatarsApi;